import { BreakPointCondition, useBreakpointIf, VStack } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import { useState } from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { TabSelector } from '../../components/TabSelector';
import { SignedInNavigationScreenNavigationProp } from '../../routes/types';

import { DocumentsCenterHeader } from './components/DocumentsCenterHeader';
import { DocumentsCenterLinksByTab, DocumentsCenterTabs, documentsCenterTabs } from './constants';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  containerInner: {
    alignItems: 'center',
  },
});

export const DocumentsCenter = () => {
  const [selectedTab, setSelectedTab] = useState<DocumentsCenterTabs>('person');
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'md');
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const ContentComponent = documentsCenterTabs[selectedTab].component;
  const listData = DocumentsCenterLinksByTab[selectedTab];

  const handleGoBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    navigation.navigate('AppDrawer', {
      screen: 'Home',
    });
  };

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.containerInner}
      showsVerticalScrollIndicator={false}>
      <VStack
        p="inset.xs"
        flex={1}
        width="full"
        maxWidth={{ base: '100%', sm: '95%', lg: '1280px' }}
        minWidth={0}
        space="stack.xxxs">
        <DocumentsCenterHeader onGoBack={handleGoBack} />
        <TabSelector
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabList={documentsCenterTabs}
          isMobile={isMobile}
        />
        <ContentComponent data={listData} />
      </VStack>
    </ScrollView>
  );
};
